export const BACKUP_LINK_EN = 'https://zoom.us/j/9776511191?pwd=dzBRN2NKYkZ6VS9JWnBnSkFpSFMxdz09';
export const BACKUP_LINK_CN = 'https://voovmeeting.com/p/7721591978';
export const SHORTENED_BACKUP_LINK_EN = 'http://bit.ly/4eTSJg3';
export const SHORTENED_BACKUP_LINK_CN = 'https://bit.ly/4eHh5te';
